<template>
  <ZigzagServiceLayout
    mainTitle="Terapia de Reposição Hormonal (TRH)"
    mainDescription="Atendimento personalizado para Equilíbrio e Vitalidade. Apoiamos e supervisionamos tratamentos hormonais de forma 100% segura para ambos os sexos."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'HormoneReplacementContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'SAÚDE FEMININA',
          title: 'Restaurando o Conforto',
          subtitle: 'Planos de tratamento personalizados para a mulher.',
          paragraphs: [
            "Desequilíbrios hormonais podem impactar profundamente a qualidade de vida da mulher. Fornecemos avaliações precisas de reposição hormonal.",
            "Se você requer terapia com estrogênio, hormônios bioidênticos ou suporte de tireoide, estamos aqui para aliviar sintomas como os da menopausa."
          ],
          list: [
            "Terapia com estrogênio e progesterona",
            "Hormônios bioidênticos",
            "Otimização da tireoide",
            "Terapias de peptídeos"
          ],
          image: '/images/services/hrt-women.png'
        },
        {
          label: 'SAÚDE MASCULINA',
          title: 'Vitalidade Masculina',
          subtitle: 'Projetado para apoiar os níveis de energia e o bem-estar geral.',
          paragraphs: [
            "Os programas de TRT ajudam a reverter a perda de energia, força e libido típicas e ligadas à testosterona baixa.",
            "Nossos planos de regulação e suporte hormonal visam restaurar também as glândulas adrenais devido ao estresse da vida contínua."
          ],
          list: [
            "Programas de Terapia Hormonal",
            "Planos de otimização de Adrenais",
            "Tratamentos discretos com resultados reais",
            "Cortisol e suporte para estresse"
          ],
          image: '/images/services/hrt-men.png'
        },
        {
          label: 'SEGURANÇA E PROTOCOLOS',
          title: 'Monitoramento Contínuo',
          subtitle: 'Tratamentos eficazes e medicamente controlados.',
          paragraphs: [
            "Nós não acreditamos em modelos únicos de terapia hormonal. Cada corpo é diferente e tratado com a devida individualidade.",
            "Disponibilizamos métodos como pílulas, cremes em gel, injeções semanais e pellets intra-cutâneos."
          ],
          list: [
            "Exames de diagnóstico de laboratório",
            "Monitoramento e ajuste constante",
            "Técnicas de Pellets, Cremes e Injeções",
            "Consultas via telemedicina para sua agilidade"
          ],
          image: '/images/services/hrt-safety.png'
        }
      ]
    };
  }
};
</script>
